import { useChannelsQuery as e, useCreateChannelMutation as t, useDeleteChannelMutation as n, useRenameChannelMutation as r } from "@frontends/data-access-spg-channels";
import { useAllInstancesQuery as i } from "@frontends/data-access-spg-instances";
import { useDataTable as a } from "@frontends/data-table";
import { DsBadge as o, DsButton as s, DsDialog as c, DsIconButton as l, DsLink as u, DsRadio as d, DsRadioGroup as f, dsToast as p } from "@frontends/ds";
import { Page as m, PageHeader as h } from "@frontends/ui-spg-layout";
import { useState as g } from "react";
import { useTranslation as _ } from "react-i18next";
import { useSearchParams as v } from "react-router";
import { jsx as y, jsxs as b } from "react/jsx-runtime";
import { useForm as x } from "@frontends/form";
import { UiKitAlertDialog as S } from "@frontends/ui-kit";
import { getApiErrorMessage as C } from "@frontends/util-api-errors";
//#region src/lib/constants.ts
var w = "feature-spg-channels", T = [
	"telegram",
	"whatsapp",
	"discord"
], E = "text-textTertiary hover:text-textPrimary focus-visible:text-textPrimary", D = "text-textTertiary hover:text-textDangerPrimary focus-visible:text-textDangerPrimary";
function O({ channelName: e, isAttached: t, onAction: n }) {
	let { t: r } = _(w);
	return /* @__PURE__ */ b("div", {
		className: "flex justify-end gap-1",
		children: [/* @__PURE__ */ y(l, {
			name: "pencil",
			size: "sm",
			className: E,
			"aria-label": r("actions.renameOf", { name: e }),
			tooltip: r("actions.rename"),
			onPress: () => n("rename")
		}), /* @__PURE__ */ y(l, {
			name: "trash-2",
			size: "sm",
			className: D,
			isDisabled: t,
			"aria-label": r("actions.deleteOf", { name: e }),
			tooltip: r(t ? "actions.attached" : "actions.delete"),
			onPress: () => n("delete")
		})]
	});
}
//#endregion
//#region src/lib/components/CreateChannelDialog.tsx
var k = {
	telegram: /^-?\d+$/,
	discord: /^\d{17,20}:\d{17,20}$/
};
function A({ isOpen: e, onOpenChange: t }) {
	let { t: n } = _(w), [r, i] = g("telegram");
	return /* @__PURE__ */ y(c, {
		title: n("create.title"),
		isOpen: e,
		onOpenChange: t,
		children: /* @__PURE__ */ b("div", {
			className: "flex flex-col gap-4",
			children: [
				/* @__PURE__ */ y(f, {
					label: n("create.platform"),
					orientation: "horizontal",
					value: r,
					onChange: (e) => i(e),
					children: T.map((e) => /* @__PURE__ */ y(d, {
						value: e,
						children: n(`platforms.${e}`)
					}, e))
				}),
				/* @__PURE__ */ y("p", {
					className: "text-base text-textSecondary",
					children: n(`create.hints.${r}`)
				}),
				/* @__PURE__ */ y(j, {
					platform: r,
					onCreated: () => t(!1)
				}, r)
			]
		})
	});
}
function j({ platform: e, onCreated: n }) {
	let { t: r } = _(w), i = t(), a = k[e], o = a ? ["required", {
		pattern: a,
		message: r(`create.invalid.${e}`)
	}] : ["required"];
	return /* @__PURE__ */ y(x({
		fields: {
			externalId: {
				type: "text",
				label: r(`create.externalId.${e}`),
				placeholder: r(`create.placeholder.${e}`),
				validators: o
			},
			name: {
				type: "text",
				label: r("create.name"),
				validators: ["required"]
			}
		},
		submitLabel: r("create.submit"),
		fieldMap: { external_id: "externalId" },
		onSubmit: async (t) => {
			let a = await i.mutateAsync({
				platform: e,
				externalId: String(t.externalId).trim(),
				name: String(t.name).trim()
			});
			p.success({ title: r("create.created", { name: a.name }) }), n();
		}
	}).Form, { className: "flex flex-col gap-4" });
}
//#endregion
//#region src/lib/components/DeleteChannelDialog.tsx
function M({ channel: e, onClose: t }) {
	let { t: r } = _(w), i = n(), a = async () => {
		try {
			await i.mutateAsync(e.id), p.success({ title: r("delete.done", { name: e.name }) });
		} catch (t) {
			p.danger({
				title: r("delete.failed", { name: e.name }),
				description: C(t, r("delete.failedFallback"))
			});
		}
	};
	return /* @__PURE__ */ y(S, {
		open: !0,
		onOpenChange: (e) => !e && t(),
		title: r("delete.title", { name: e.name }),
		description: r("delete.description"),
		confirmLabel: r("delete.confirm"),
		cancelLabel: r("delete.cancel"),
		onConfirm: () => void a()
	});
}
//#endregion
//#region src/lib/components/RenameChannelDialog.tsx
function N({ channel: e, onClose: t }) {
	let { t: n } = _(w), i = r(), a = x({
		fields: { name: {
			type: "text",
			label: n("rename.name"),
			defaultValue: e.name,
			validators: ["required", { maxLength: 256 }]
		} },
		submitLabel: n("rename.submit"),
		onSubmit: async (r) => {
			let a = String(r.name).trim();
			await i.mutateAsync({
				id: e.id,
				name: a
			}), p.success({ title: n("rename.done", { name: a }) }), t();
		}
	});
	return /* @__PURE__ */ y(c, {
		title: n("rename.title"),
		isOpen: !0,
		onOpenChange: (e) => !e && t(),
		children: /* @__PURE__ */ y(a.Form, { className: "flex flex-col gap-4" })
	});
}
//#endregion
//#region src/lib/pages/ChannelsPage.tsx
function P({ getInstanceHref: t }) {
	let { t: n } = _(w), r = v(), c = i().data ?? [], l = new Map(c.flatMap((e) => e.channels.map((t) => [t.id, e]))), [d, f] = g(!1), [p, x] = g(null), S = () => x(null), C = [
		{
			id: "name",
			label: n("columns.name"),
			isRowHeader: !0,
			isSortable: !0,
			cell: (e) => e.name
		},
		{
			id: "platform",
			label: n("columns.platform"),
			isSortable: !0,
			width: 160,
			skeleton: "pill",
			cell: (e) => /* @__PURE__ */ y(o, { children: n(`platforms.${e.platform}`) })
		},
		{
			id: "externalId",
			label: n("columns.externalId"),
			cell: (e) => /* @__PURE__ */ y("span", {
				className: "font-mono",
				children: e.externalId
			})
		},
		{
			id: "instance",
			label: n("columns.instance"),
			cell: (e) => {
				let r = l.get(e.id);
				return r ? /* @__PURE__ */ y(u, {
					href: t(r.id),
					children: r.name
				}) : /* @__PURE__ */ y("span", {
					className: "text-textTertiary",
					children: n("columns.noInstance")
				});
			}
		},
		{
			id: "actions",
			label: n("columns.actions"),
			align: "end",
			width: 120,
			cell: (e) => /* @__PURE__ */ y(O, {
				channelName: e.name,
				isAttached: l.has(e.id),
				onAction: (t) => x({
					action: t,
					channel: e
				})
			})
		}
	], E = a({
		"aria-label": n("table.label"),
		columns: C,
		defaultSort: {
			by: "name",
			order: "asc"
		},
		getRowKey: (e) => e.id,
		searchParams: r,
		filters: {
			platform: {
				type: "chips",
				label: n("filters.platform"),
				defaultValue: "all",
				options: [{
					value: "all",
					label: n("filters.allPlatforms")
				}, ...T.map((e) => ({
					value: e,
					label: n(`platforms.${e}`)
				}))]
			},
			query: {
				type: "search",
				label: n("filters.search"),
				defaultValue: ""
			}
		}
	}), D = e(E.requestParams, E.filters);
	return /* @__PURE__ */ b(m, { children: [
		/* @__PURE__ */ y(h, { title: n("title") }),
		/* @__PURE__ */ b(E.Frame, { children: [/* @__PURE__ */ y(E.Toolbar, { children: /* @__PURE__ */ y(s, {
			iconStart: "plus",
			onPress: () => f(!0),
			children: n("create.open")
		}) }), /* @__PURE__ */ y(E.Table, {
			query: D,
			emptyState: {
				icon: "hash",
				title: n("empty.title"),
				actionLabel: n("create.open"),
				onAction: () => f(!0)
			}
		})] }),
		/* @__PURE__ */ y(A, {
			isOpen: d,
			onOpenChange: f
		}),
		p?.action === "rename" && /* @__PURE__ */ y(N, {
			channel: p.channel,
			onClose: S
		}),
		p?.action === "delete" && /* @__PURE__ */ y(M, {
			channel: p.channel,
			onClose: S
		})
	] });
}
//#endregion
export { P as ChannelsPage, w as FEATURE_SPG_CHANNELS_NAMESPACE };
